var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reviews-awards" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "ra-sections" }, [
                  _vm.awards.length > 0
                    ? _c(
                        "div",
                        { staticClass: "awards-section ra-section" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _c("h2", [_vm._v("Awards")]),
                          ]),
                          _vm._v(" "),
                          _c("awards-section", {
                            attrs: { content: _vm.awards },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "reviews-section ra-section" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("h2", [_vm._v("Reviews")]),
                      ]),
                      _vm._v(" "),
                      _vm.reviews.length > 0
                        ? [
                            _c("reviews-section", {
                              attrs: { content: _vm.reviews },
                            }),
                          ]
                        : [
                            _c("p", [
                              _vm._v("0 reviews found for this product."),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }